var e = /* @__PURE__ */ ((r) => (r.Medium = "medium", r.Small = "small", r))(e || {}), t = /* @__PURE__ */ ((r) => (r.Primary = "primary", r.PrimaryDestructive = "primaryDestructive", r.Secondary = "secondary", r.SecondaryDestructive = "secondaryDestructive", r.Ghost = "ghost", r.GhostDestructive = "ghostDestructive", r.Brand = "brand", r))(t || {});
export {
  e as SizesEnum,
  t as VariantsEnum
};
